exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".odd{\n    background-color:#ffffff ;\n}\n.even{\n    background-color:#e6e6e6;\n}\n\ntable.bgborder, table.bgborder > thead > tr > th, table.bgborder > tbody > tr > td {\n    border: 1px solid #848a87;\n}\n\n.filter {\n    margin-top: 5px;\n    width: 150px;\n    /* margin-right: 31px; */\n    margin-bottom: 0px;\n}\n\n.text-center{\n    text-align: center\n}\n\n.average_score{\n    text-align: center;\n    font-weight: bold;\n    margin-bottom: 20px;\n    margin-top: 10px;\n}\n\n.table-striped>tbody>tr:nth-of-type(odd) {\n    background-color: #e6e6e6;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/app/accountGoals/team-goals/team-goals.component.css
// module id = ../../../../../src/app/accountGoals/team-goals/team-goals.component.css
// module chunks = main